package com.exura.chartsJS

import com.exura.util.jso
import kotlin.reflect.KProperty

abstract class DatasetScope(val type: String) {
    internal val config = jso { this.type = type }

    var label: String? by Prop(config)
    var backgroundColor: String? by Prop(config)
    var borderColor: String? by Prop(config)
    var borderWidth: Int? by Prop(config)
    var order: Int? by Prop(config)
    var yAxisID: String? by Prop(config)

    class Prop<T>(private val obj: dynamic) {
        operator fun getValue(thisRef: Any?, property: KProperty<*>): T? =
            obj[property.name] as? T
        operator fun setValue(thisRef: Any?, property: KProperty<*>, value: T?) {
            obj[property.name] = value
        }
    }
}

class LineDatasetScope : DatasetScope("line") {
    var tension: Double? by Prop(config)
    var fill: Boolean? by Prop(config)
    var pointRadius: Int? by Prop(config)
    var pointHoverRadius: Int? by Prop(config)
    var showLine: Boolean? by Prop(config)
}

class BarDatasetScope : DatasetScope("bar") {
    var borderRadius: Int? by Prop(config)
    var stack: String? by Prop(config)

    var barPercentage: Double? by Prop(config)
    var categoryPercentage: Double? by Prop(config)
}

class ScatterDatasetScope : DatasetScope("scatter") {
    var pointRadius: Int? by Prop(config)
}
